import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/activation/$token/account')({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello /activation/$token/account!</div>;
}
